import {ShopHongPrizeEntity} from "./ShopLotteryNewGGLPrefab";
import O1HD from "../../../../../../engines/gameEngine";
import ShopNewGGLNode from "./ShopNewGGLNode";
import { GeneralKind } from "../../../../../define/GeneralKind";
import data_control from "../../../../../../engines/libs/data_control";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../../../BundleResourceConfig";
import NormalGameManager from "../../../../manager/NormalGameManager";
import { FileKind } from "../../../../../define/FileKind";
import utilsView from "../../../../../../engines/libs/utilsView";

const {ccclass, property} = cc._decorator;

const g_specialNum = 8888;
@ccclass
export default class ShopNewGglItemNode extends cc.Component {

    @property(cc.Node)
    nodeBlindBox: cc.Node = null;
    @property({type: cc.Sprite,displayName:"名称1"})
    lbNumArray : cc.Sprite[] = [];
    @property({type:cc.Label,displayName:"金额"})
    lbPrize : cc.Label = null;
    @property(cc.Node)
    nodeLabelUnits: cc.Node = null;

    @property(cc.Node)
    judge1Node : cc.Node = null;
    @property(cc.Node)
    judge2Node : cc.Node = null;
    @property(cc.Node)
    judge3Node : cc.Node = null;
    @property(cc.Node)
    judge4Node : cc.Node = null;
    @property(cc.Node)
    ZjNode : cc.Node = null;

    flag1 : boolean = false;
    flag2 : boolean = false;
    flag3 : boolean = false;
    flag4 : boolean = false;


    private mParentScript : ShopNewGGLNode;
    private mHongDefine : ShopHongPrizeEntity;
    private mId : string;
    /** 特殊奖励 */
    private bSpecialAward = false;
    private bShowSpecialAward = false;

    onLoad () {
        O1HD.on("ShopNewGglItemNode.checkJudgeNode" , this.checkJudgeNode , this );
        O1HD.on("ShopNewGglItemNode.remove" , this.remove , this );
        O1HD.on("ShopNewGglItemNode.triggerFlagPrizeOpen" , this.triggerFlagPrizeOpen , this );
        O1HD.on("ShopNewGglItemNode.checkJudge" , this.checkJudge , this );
    }

    start () {
        this.lbNumArray.forEach((v)=> {
            v.node.active = false;
        });
    }

    setShowSpecialAward(enable: boolean) {
        this.bShowSpecialAward = enable;
    }

    /**
     * 绑定数据
     */
    bindData( parentScript : ShopNewGGLNode , id : string ){
        this.mParentScript = parentScript;
        this.mId = id;
    }

    /**
     *
     * @param pos
     * @param pos2
     */
    checkJudge( pos : cc.Vec2 , pos2 : cc.Vec2 ){
        if ( cc.Intersection.lineRect( pos , pos2 , this.node.getBoundingBoxToWorld() )
         && this.mHongDefine == null 
        ) {
            this.setAward();
        }
        if ( !this.flag1 &&  cc.Intersection.lineRect( pos , pos2 , this.judge1Node.getBoundingBoxToWorld() ) ) {
            this.flag1 = true;
            this._checkFinish();
        }
        if ( !this.flag2 &&  cc.Intersection.lineRect( pos , pos2 , this.judge2Node.getBoundingBoxToWorld() ) ) {
            this.flag2 = true;
            this._checkFinish();
        }
        if ( !this.flag3 &&  cc.Intersection.lineRect( pos , pos2 , this.judge3Node.getBoundingBoxToWorld() ) ) {
            this.flag3 = true;
            this._checkFinish();
        }
        if ( !this.flag4 && cc.Intersection.lineRect( pos , pos2 , this.judge4Node.getBoundingBoxToWorld() ) ) {
            this.flag4 = true;
            this._checkFinish();
        }
    }

    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        let circleSize = GeneralKind.ScratchTicketValue.EVERY_CIRCLE_ADJUST + 1;
        
        let rect = cc.rect( pos.x - circleSize  , pos.y - circleSize , circleSize*2 , circleSize*2 );
        if ( this.node.getBoundingBoxToWorld().containsRect( rect ) && this.mHongDefine == null ) {
            //如果包含这个世界坐标 切 奖项定义为空
            this.setAward();
        }
        if ( !this.flag1 && this.judge1Node.getBoundingBoxToWorld().containsRect( rect ) ) {
            this.flag1 = true;
            this._checkFinish();
            // return ;
        }
        if ( !this.flag2 && this.judge2Node.getBoundingBoxToWorld().containsRect( rect ) ) {
            this.flag2 = true;
            this._checkFinish();
            // return;
        }
        if ( !this.flag3 && this.judge3Node.getBoundingBoxToWorld().containsRect( rect ) ) {
            this.flag3 = true;
            this._checkFinish();
            // return ;
        }
        if ( !this.flag4 && this.judge4Node.getBoundingBoxToWorld().containsRect( rect ) ) {
            this.flag4 = true;
            this._checkFinish();
            // return;
        }
    }

    //
    private hasOpenFlag : boolean = false;
    private alreadyOpenFlag : boolean = false;
    private _checkFinish(){
        if ( this.flag1 && this.flag2 && this.flag3 && this.flag4 && !this.hasOpenFlag ) {
            this.hasOpenFlag = true;
            this._prize();
        }
    }

    setAward() {
        this.mHongDefine = this.mParentScript.mParentScript.getPrize();
        if (this.bShowSpecialAward) {
            this.mHongDefine.flag = true;
            this.mHongDefine.name = "" + g_specialNum;
            this.mHongDefine.prize = g_specialNum;
        }
        this._refreshData();
    }

    /**
     * 触发 prize
     * @param flagPrizeOpenFlag
     */
    triggerFlagPrizeOpen( openPrize : number ){
        this._prize();
    }

    private _prize(){
        if ( this.hasOpenFlag ) {
            // 开奖
            if ( this.alreadyOpenFlag == false ) {
                if (this.bSpecialAward) {
                    // 特殊奖励
                    this.openSpecialAward();
                } else {
                    this.mParentScript.openPrize( this.mHongDefine , this.node );
                }
                if ( this.mHongDefine.flag ) {
                    this.ZjNode.active = true;
                    this.ZjNode.opacity = 0;
                    cc.tween( this.ZjNode )
                        // .to( 3 , { opacity : 255 })
                        .to( 1.2 , { opacity : 255 })
                        .call( ()=>{

                        }).start();
                }
            }
            this.alreadyOpenFlag = true;
        }
    }

    openSpecialAward() {
        let goodsId = GeneralKind.PropId.ANIMAL_GOODS_ID;
        NormalGameManager._instance.onPushGoods(goodsId,1);
        let prefabFile = FileKind.PrefabFilePath.AcquireSepecialAwardLayer;
        utilsView.openPopupLayerTwo(
            prefabFile
            , null
            , {goodsId: goodsId}
        );
    }
    
    /**
     *
     * @private
     */
    _refreshData(){
        this.nodeBlindBox.active = false;
        this.lbPrize.string = this.mHongDefine.name;
        // 中奖
        if ( this.mHongDefine.flag ) {
            let maxCount = GeneralKind.ScratchTicketValue.ANIMAL_COUNT;
            let rnum = data_control.randomNumInt(1, maxCount);
            // let mCurrPrizeNum = Math.floor( Math.random() * 98 ) + 1;
            let probability = GeneralKind.ScratchTicketValue.SPECIAL_ANIMAL_PROBABILITY;
            let specialNum = GeneralKind.ScratchTicketValue.SPECIAL_ANIMAL_NUM;
            let isExistsSpecial = this.mParentScript.isExistsSpecial();
            if (!isExistsSpecial && data_control.isHitProbability(probability)) {
                this.nodeBlindBox.active = true;
                this.nodeLabelUnits.active = false;
                this.lbPrize.node.active = false;
                this.bSpecialAward = true;
                this.mParentScript.setSpecialValue();
                // let randomNum = this.getRandomNumNotEq8();
                let randomIndex = Math.floor( Math.random() * 3 );
                for ( let i = 0 ; i < 3 ; i ++ ) {
                    if ( i == randomIndex ) {
                        this.setNumUI(i, specialNum);
                    }else{
                        this.setNumUI(i, rnum);
                    }
                }
            } else {
                for ( let i = 0 ; i < 3 ; i ++ ) {
                    this.setNumUI(i, rnum);
                }
            }
        } else {
            // 未中奖
            let notRepeatNumArray = this.getNotRepeatNums();
            for ( let i = 0 ; i < notRepeatNumArray.length ; i ++ ) {
                this.setNumUI(i, notRepeatNumArray[i]);
            }
        }
    }

    setNumUI(idx: number, num: number | string) {
        // this.lbNumArray[idx].string = '' + num;
        getOneBundle(BUNDLE_SMALL_NAME.shopGameBundle).then((bundle:cc.AssetManager.Bundle)=>{
            bundle.load('asset/animal/' + num, cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log(err);
                }else{
                    this.lbNumArray[idx].spriteFrame = asset;
                    this.lbNumArray[idx].node.active = true;
                }
            });
        });
    }

    /**
     * 获取不重复的数字
     */
    getNotRepeatNums() : number[]{
        let retNum : number[] = [];
        // let tempNum : number[] = [];
        // let specialNum = GeneralKind.ScratchTicketValue.SPECIAL_ANIMAL_NUM;
        let maxCount = GeneralKind.ScratchTicketValue.ANIMAL_COUNT;
        // for( let i = 1 ; i <= maxCount ; i++ ){
        //     if ( i == specialNum ) {
        //         continue;
        //     }
        //     tempNum.push( i );
        // }
        // for ( let i = 0 ; i < 3 ; i++ ) {
        //     let randomIndex = Math.floor( Math.random() * tempNum.length );
        //     retNum = retNum.concat( tempNum.splice( randomIndex , 1 ) );
        // }

        let generateCount = 3;
        while(retNum.length < generateCount) {
            let rnum = data_control.randomNumInt(1, maxCount);
            if (retNum.includes(rnum)) {
                continue;
            }
            retNum.push(rnum);
        }

        return retNum;
    }

    getRandomNumNotEq8(){
        let randomNum = Math.floor( Math.random() * 98 ) + 1;
        return randomNum == 8 ? randomNum + 1 : randomNum;
    }

    remove(){
        if ( this.node ) {
            this.node.removeFromParent();
            this.node.destroy();
        }
    }


}
